import React from "react";
import TransactionTable from "./components/TransactionTable";
function CompanyTransactions() {
  return (
    <div>
      <TransactionTable />
    </div>
  );
}

export default CompanyTransactions;
